export const isFunction = (fnc: any) => fnc && fnc.call && fnc.apply && typeof fnc === 'function'
